import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, map, take } from 'rxjs';
import { WorkspaceState } from '../store/state';
import { selectReferenceDocument } from '../store/selectors';

export const referenceDocumentGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const workspaceId = route.params['id'];
  const store = inject<Store<WorkspaceState>>(Store);
  const router = inject(Router);

  return store.select(selectReferenceDocument).pipe(
    take(1),
    map((referenceDocument) =>
      referenceDocument ? true : router.createUrlTree(['/workspaces', workspaceId]),
    ),
  );
};
